import {
  type ComputedRef,
  type ExtractPropTypes,
  type InjectionKey,
  computed,
  defineComponent,
} from 'vue'
import { makeNumericProp } from '@xzx-design/utils'
import { useChildren, useNamespace } from '@xzx-design/hooks'

export type SidebarProvide = {
  getActive: () => number
  setActive: (value: number) => void
  currentIndex: ComputedRef<string | number>
}

const name = 'XzxSidebar'

export const SIDEBAR_KEY: InjectionKey<SidebarProvide> = Symbol(name)

export const sidebarProps = {
  modelValue: makeNumericProp(0),
}

export type SidebarProps = ExtractPropTypes<typeof sidebarProps>

export default defineComponent({
  name,

  props: sidebarProps,

  emits: ['change', 'update:modelValue'],

  setup(props, { emit, slots }) {
    const { bem } = useNamespace('sidebar')
    const { linkChildren } = useChildren(SIDEBAR_KEY)

    const getActive = () => +props.modelValue

    const setActive = (value: number) => {
      if (value !== getActive()) {
        emit('update:modelValue', value)
        emit('change', value)
      }
    }

    const currentIndex = computed(() => props.modelValue)

    linkChildren({
      getActive,
      setActive,
      currentIndex,
    })

    return () => (
      <div role="tablist" class={bem()}>
        {slots.default?.()}
      </div>
    )
  },
})
